Wee.fn.make('notificationBar', {
	init: function() {
		this.$private.initialize();
	}
}, {
	initialize: function() {
		var $closePromo = $('ref:closePromo');

		if ($closePromo.length && ! this.entryIsInStorage($closePromo.data('entryId'))) {
			$('ref:promoBar').show();

			this.bind();
		}
	},

	bind: function() {
		var scope = this;

		$('ref:closePromo').on('click', function(e, el) {
			scope.addEntryToStorage($(el).data('entryId'));

			$('ref:promoBar').hide();
		});
	},

	addEntryToStorage: function(id) {
		var currentClosedEntries = JSON.parse(localStorage.getItem('closedPromos'));

		if (! currentClosedEntries) {
			currentClosedEntries = [];
		}

		currentClosedEntries.push(id);

		localStorage.setItem('closedPromos', JSON.stringify(currentClosedEntries));
	},

	entryIsInStorage: function(id) {
		var $closedEntries = JSON.parse(localStorage.getItem('closedPromos'));

		if (! $closedEntries) {
			return false;
		}

		return $closedEntries.indexOf(id) > -1;
	}
});